import { render, staticRenderFns } from "./ePharmacyPatient.vue?vue&type=template&id=3ae874b9&"
import script from "./ePharmacyPatient.vue?vue&type=script&lang=js&"
export * from "./ePharmacyPatient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports